<template>
  <CCol sm="12" tag="section" class="mainColumns p-4">
    <CRow>
      <CCol sm="12" md="6">
        <CRow class="py-3">
          <CCol sm="12" md="7">
            <div class="d-flex mb-3">
              <i class="icon icon__key icon__keyGrayDark mr-1"></i>
              <h5 class="mainColumns__title font-weight-semi-bold text-uppercase">
                {{ $t('audience.organize.mainColumns.header5.key-coloumns') }}
              </h5>
            </div>
            <ul v-if="hasAudience" class="mainColumns__keyBox d-flex flex-wrap p-0">
              <li
                v-for="key in optionMainColumSelected"
                :key="key.value"
                class="mainColumns__keyBoxItem m-1 bg-white py-1 px-2"
              >
                {{ key.value }}
              </li>
            </ul>
            <multiselect
              v-else
              v-model="values"
              class="ml-0 multiselect--tags"
              selectLabel="Select"
              deselectLabel="Deselect"
              :group-select="false"
              :options="optionMainColumn"
              :custom-label="customLabel"
              :multiple="true"
              :taggable="true"
              :searchable="false"
              @input="updateMainColumn($event)"
              id="main-key"
              placeholder="Select a main Column"
              label="key"
              track-by="key"
            >
            </multiselect>
          </CCol>
          <CCol sm="12" md="5" class="mt-4 pl-4">
            <h6 class="font-weight-semi-bold mb-3 text-uppercase">
              {{ $t('audience.organize.mainColumns.header6.what-are-they-for') }}
            </h6>
            <p>{{ $t('audience.organize.mainColumns.text.what-are-they-for-desc') }}</p>
          </CCol>
        </CRow>
      </CCol>
      <CCol sm="12" md="5">
        <CRow class="py-3">
          <CCol sm="12" :md="{ size: 9, offset: 1 }" class="mt-4 divider">
            <div class="d-flex align-items-center mb-3">
              <i class="fas fa-exclamation text-white bg-primary exclamation mr-2"></i>
              <h6 class="font-weight-semi-bold mb-0 text-uppercase text-primary">
                {{ $t('audience.organize.mainColumns.header6.important') }}
              </h6>
            </div>
            <p>{{ $t('audience.organize.mainColumns.text.importat-desc') }}}</p>
          </CCol>
        </CRow>
      </CCol>
    </CRow>
  </CCol>
</template>

<script>
import { customLabel } from './../../mixins/index'
export default {
  name: 'MainColumns',
  data() {
    return {}
  },
  mixins: [customLabel],
  methods: {
    updateMainColumn(values) {
      this.$emit('updateMainColumn', values)
    }
  },

  computed: {
    optionMainColumn() {
      return this.$store.getters['audience/optionMainColumn'] || []
    },

    values: {
      get() {
        return this.$store.getters['audience/optionMainColumSelected'] || []
      },

      set(value) {
        this.$store.dispatch('audience/updateMainColumn', { event: 'select', items: value })
      }
    },

    optionMainColumSelected() {
      return this.$store.getters['audience/optionMainColumSelected']
    },

    hasAudience() {
      return this.$store.state.audience.hasAudience
    }
  }
}
</script>

<style lang="scss" scoped>
.mainColumns {
  background: #edeff1;
  color: var(--gray-600);

  &__title {
    color: #7f889a;
  }

  &__keyBox {
  }

  &__keyBoxItem {
    border-radius: 4px;
  }

  .divider {
    border-left: 1px solid #d1d4da;
    padding-left: 5em;
  }

  p {
    line-height: 1.3rem;
  }
}
</style>
